import CoreLayout from '../layouts/CoreLayout';
import { injectReducer } from '../store/reducers';
import EventsContainer from './Events/containers/EventsContainer';
//Sync route definition
const indexRouteComponent = { component: EventsContainer };
// TODO : fix so it goes to /events and highlights the left tab properly.
// Create action for directing to /events in sidebar and dispatch it onEnter
//
export const createRoutes = (store) => ({
  path: '/',
  component: CoreLayout,
  onEnter: () => {
    const reducer = require('./Events/modules/eventChron').default;
    const templateChronReducer = require('../routes/Templates/modules/templateChron')
      .default;
    const templateFormReducer = require('../routes/Templates/common/modules/templateForm')
      .default;

    injectReducer(store, { key: 'event_chron', reducer: reducer });
    injectReducer(store, {
      key: 'template_chron',
      reducer: templateChronReducer,
    });

    injectReducer(store, {
      key: 'template_form',
      reducer: templateFormReducer,
    });
  },
  indexRoute: indexRouteComponent,
  getChildRoutes(location, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./Templates').default(store),
        require('./Events').default(store),
        require('./Offers').default(store),
        require('./Tools').default(store),
        require('./EventDetails').eventInfo(store),
        require('./EventDetails').default(store),
        require('./Login').default(store),
        require('./Logout').default(store),
        require('./Healthcheck').default(store),
        require('./notFound').default(store),

        //require addition routes here
      ]);
    });
  },
});

export default createRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.js